<div class="wrapper">
    <header class="header navbar navbar-expand-md row">
        <h2 class="col col-sm-7">RTO Exam Preparation</h2>
        <div class="row col col-sm-5">
            <div class="login-btn col col-sm-6">
                <a href="index.html"><button class="btn-fill"><p>HOME</p></button></a>
            </div>            
            <div class="login-btn col col-sm-6">
                <a href="login.html"><button class="btn-fill"><p>LOGIN</p></button></a>
            </div>
        </div>        
    </header>
<section class="container">
    <!-- <div class="wrapper"> -->
        <div class="instruction">
            <h3>You Have Successfully Completed Test.</h3>
            <h5 class="correct">Correct Answer : {{ truecnt }}</h5>
            <h5 class="wrong">Wrong Answer : {{ falsecnt }}</h5> 
        </div>
        <div class="question">
            <div class="que-main-head">                    
                <div class="que-head">
                    <h1>Total Question {{ truecnt + falsecnt }}:</h1>                          
                </div>
            </div>
            <!-- <form action="submitted.html"> -->
                <!-- <div class="que">
                    <h3>Q. While driving at nights on city roads, keep your head-lights on a</h3>
                    <div class="option correct">
                        <input TYPE="RADIO" VALUE="A" NAME="aa">
                        <p>Low Beam</p>
                    </div>
                    <div class="option wrong">
                        <input TYPE="RADIO" VALUE="B" NAME="aa"> 
                        <p>High Beam</p>
                    </div>
                    <div class="option">
                        <input TYPE="RADIO" VALUE="C" NAME="aa"> 
                        <p>Switch of all lighs</p>
                    </div>
                </div> 
                
                <div class="que">
                    <h3>Q. What does following sign represent?</h3><br>
                    <img src=".\images\queimg\bullcardprohibited.jpg">
                    <div class="option correct">
                        <input TYPE="RADIO" VALUE="A" NAME="cc" > 
                        <p>Bullock cart prohibited.</p>
                    </div>
                    <div class="option">
                        <input TYPE="RADIO" VALUE="B" NAME="cc" >
                        <p>Cycle prohibited.</p>
                    </div>
                    <div class="option wrong">
                        <input TYPE="RADIO" VALUE="C" NAME="cc" > 
                        <p>All vehicles prohibited.</p>
                    </div>
                </div>  -->
                
                <!-- <div class="que">
                    <h3>Q. Red Traffic Light Indicates</h3>                
                    <div class="option">
                        <input TYPE="RADIO" VALUE="A" NAME="bb" > 
                        <p>Vehicles can proceed with cautions</p>
                    </div>
                    <div class="option correct">
                        <input TYPE="RADIO" VALUE="B" NAME="bb" >
                        <p>Stop the vehicles</p>
                    </div>
                    <div class="option wrong">
                        <input TYPE="RADIO" VALUE="C" NAME="bb" > 
                        <p>Slow down</p>
                    </div>
                </div>                      -->
            <!-- </form> -->
            <div *ngIf="fetchedSelection?.length > 0 && fetchedQue?.length > 0; else  quefail">
                <div *ngFor="let sq of fetchedQue; let index = index">
                    <div class="que">
                        <h3>{{ index+1 }}. {{ sq.que }}</h3>
                        <div *ngIf="sq.hasImg">                            
                            <img src="../../../assets/QueImg/{{ sq.imgurl }}">                            
                        </div> 
                        <!-- {{ sq.ans }} -->
                        <div *ngIf="sq.ans == 1">                            
                            <div class="option correct">                                                                
                                <div *ngIf="sq.op1 == fetchedSelection[index].option;">
                                    <input type="radio" value="{{ option }}" name="{{ index }}" checked/>                                
                                    <p>{{ sq.op1 }}</p>
                                </div>
                                <div *ngIf="sq.op1 != fetchedSelection[index].option;">
                                    <input type="radio" value="{{ option }}" name="{{ index }}" disabled/>                                
                                    <p>{{ sq.op1 }}</p>
                                </div>                                
                            </div>                            
                        </div>
                        <div *ngIf="sq.ans != 1">
                            <div *ngIf="sq.op1 == fetchedSelection[index].option;">                                                           
                                <div class="option wrong">                                
                                     <input type="radio" value="{{ option }}" name="{{ index }}" checked/> 
                                    <p>{{ sq.op1 }}</p>                 
                                </div>                                
                            </div>
                            <div *ngIf="sq.op1 != fetchedSelection[index].option;">                                                           
                                <div class="option">                                
                                     <input type="radio" value="{{ option }}" name="{{ index }}" disabled/> 
                                    <p>{{ sq.op1 }}</p>                 
                                </div>                                
                            </div>                            
                        </div>

                        <div *ngIf="sq.ans == 2">                            
                            <div class="option correct">                                                                
                                <div *ngIf="sq.op2 == fetchedSelection[index].option;">
                                    <input type="radio" value="{{ option }}" name="{{ index }}" checked/>                                
                                    <p>{{ sq.op2 }}</p>
                                </div>
                                <div *ngIf="sq.op2 != fetchedSelection[index].option;">
                                    <input type="radio" value="{{ option }}" name="{{ index }}" disabled/>                                
                                    <p>{{ sq.op2 }}</p>
                                </div>                                
                            </div>                            
                        </div>
                        <div *ngIf="sq.ans != 2">
                            <div *ngIf="sq.op2 == fetchedSelection[index].option;">                                                           
                                <div class="option wrong">                                
                                     <input type="radio" value="{{ option }}" name="{{ index }}" checked/> 
                                    <p>{{ sq.op2 }}</p>                 
                                </div>                                
                            </div>
                            <div *ngIf="sq.op2 != fetchedSelection[index].option;">                                                           
                                <div class="option">                                
                                     <input type="radio" value="{{ option }}" name="{{ index }}" disabled/> 
                                    <p>{{ sq.op2 }}</p>                 
                                </div>                                
                            </div>                            
                        </div>

                        <div *ngIf="sq.ans == 0">                            
                            <div class="option correct">                                                                
                                <div *ngIf="sq.op3 == fetchedSelection[index].option;">
                                    <input type="radio" value="{{ option }}" name="{{ index }}" checked/>                                
                                    <p>{{ sq.op3 }}</p>
                                </div>
                                <div *ngIf="sq.op3 != fetchedSelection[index].option;">
                                    <input type="radio" value="{{ option }}" name="{{ index }}" disabled/>                                
                                    <p>{{ sq.op3 }}</p>
                                </div>                                
                            </div>                            
                        </div>
                        <div *ngIf="sq.ans != 0">
                            <div *ngIf="sq.op3 == fetchedSelection[index].option;">
                                <div class="option wrong">                                
                                     <input type="radio" value="{{ option }}" name="{{ index }}" checked/> 
                                    <p>{{ sq.op3 }}</p>                 
                                </div>                                
                            </div>
                            <div *ngIf="sq.op3 != fetchedSelection[index].option;">                                                           
                                <div class="option">                                
                                     <input type="radio" value="{{ option }}" name="{{ index }}" disabled/> 
                                    <p>{{ sq.op3 }}</p>                 
                                </div>                                
                            </div>                            
                        </div>
                                                                
                        <!-- {{ index }} -->
                    </div>
                </div>
            </div>
            <ng-template #quefail>
                <p>If Question is not available Restart it.</p>
                <button type="submit" id="submitbtn" class="btn-fill">Restart</button>
            </ng-template> 
        </div>
    <!-- </div> -->
</section>

<footer class="page-footer footer">        
    <h5>coyright &copy; 2020,MS-creation</h5>
</footer>
</div>